<div class="content">
  <div class="content-panel">
    Vous allez être redirigé vers InnoV.
  </div>
</div>